<script setup>
    import ModalHeader from './ModalHeader.vue';
    import ModalFooter from './ModalFooter.vue';
    import ModalBody from '@/components/vue-components/bootstrap-components/ModalBody.vue';
    import PublicAlertModal from '@/vue/guest/shared/modals/PublicAlertModal.vue';

    const props = defineProps({
        noFade: { type: Boolean, default: false },
        id: { type: String },
        static: { type: Boolean, default: false },
        size: { type: String },
        title: String,
        noFooter: { type: Boolean, default: false },
        show: { type: Boolean, default: false },
        contentClass: String
    });
</script>

<template>
    <!-- Modal -->
    <div
        class="modal"
        :class="{
            fade: !noFade,
            show: show
        }"
        :id="id ?? ''"
        :data-bs-backdrop="static ? 'static' : null"
        :data-bs-keyboard="static ? 'false' : null"
        tabindex="-1"
        :aria-labelledby="title ? `${id ?? ''}Label` : undefined"
        aria-hidden="true"
        aria-modal="true"
        role="dialog">
        <div
            class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
            :class="size !== undefined ? `modal-${size}` : ''">
            <div class="modal-content" :class="contentClass">
                <modal-header v-if="title" :id="`${id ?? ''}Label`" :title="title"></modal-header>

                <!--                Allow to use custom body (likely for a form)-->
                <modal-body v-if="!$slots.body">
                    <slot v-if="!$slots.body"></slot>
                </modal-body>
                <slot v-else name="body"></slot>

                <modal-footer
                    v-if="!noFooter"
                    :buttons="[
                        { text: $t('Close'), color: 'secondary', dismiss: 'modal' }
                    ]"></modal-footer>
                <slot name="footer"></slot>
            </div>
            <!-- end modal content-->
        </div>
        <!-- end modal dialog-->
    </div>
    <!-- end modal-->
</template>

<script>
    export default {
        name: 'Modal'
    };
</script>
